import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=2665a82c"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2665a82c')) {
      api.createRecord('2665a82c', component.options)
    } else {
      api.reload('2665a82c', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=2665a82c", function () {
      api.rerender('2665a82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/components/editor.vue"
export default component.exports